import React from "react";
import { Link } from "react-router-dom";
import { Award, Building2, Target, Users } from "lucide-react";
import { CoreValuesOrbit } from "../components/CoreValuesOrbit";
import { WhoWeServe, PolicyProcedures } from "../components/AboutSections";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="bg-navy text-white section-pad">
        <div className="container-x">
          <span className="accent-bar mb-4" />
          <h1 className="font-heading text-4xl md:text-6xl font-extrabold tracking-tight max-w-3xl">About Crew Connect FinInvesto</h1>
          <p className="mt-4 text-white/80 max-w-2xl">A premier financial consultancy and direct lending partner specializing in high-ticket secured and unsecured funding.</p>
        </div>
      </section>

      <section className="container-x section-pad grid lg:grid-cols-2 gap-12 items-center">
        <div className="grid grid-cols-2 gap-4">
          <img src="/images/about-handshake.jpg" alt="Trusted business handshake" className="rounded-sm w-full h-72 md:h-96 object-cover" />
          <img src="/images/family-consult.jpg" alt="Advisory consultation with clients" className="rounded-sm w-full h-72 md:h-96 object-cover mt-8" />
        </div>
        <div>
          <span className="accent-bar mb-3" />
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-navy">Bridging Capital and Ambition</h2>
          <p className="text-muted-foreground mt-4 leading-relaxed">
            CrewConnect FinInvesto bridges the gap between complex business requirements and capital availability. From Nationalized Banks and NBFCs to Private Institutional Funding, we provide tailored liquidity solutions for Mid-Corporate Industries, Traders, and Builders across Pan-India.
          </p>
          <p className="text-muted-foreground mt-4 leading-relaxed">
            We serve as a vital financial bridge for Chartered Accountants, Chief Financial Officers, and Corporate Leaders. Our portfolio includes Overdraft and Cash Credit limits, Letter of Credit and Bank Guarantee issuances, and Private Unsecured Funding.
          </p>
        </div>
      </section>

      <CoreValuesOrbit />
      <WhoWeServe />

      {/* PILLARS */}
      <section className="section-pad" data-testid="pillars-section">
        <div className="container-x">
          <span className="accent-bar mb-3" />
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-navy">Our Pillars</h2>
          <div className="grid md:grid-cols-4 sm:grid-cols-2 gap-6 mt-10">
            {[
              { i: <Target />, t: "Mission", d: "Connect every viable business to the right capital partner — fast, transparent and stress-free." },
              { i: <Award />, t: "Vision", d: "To become India's most trusted facilitator for high-ticket and challenging funding mandates." },
              { i: <Users />, t: "Clients", d: "Manufacturers, traders, builders, aviation firms, NBFCs, listed companies and salaried professionals." },
              { i: <Building2 />, t: "Reach", d: "Active across Delhi NCR, Mumbai, Lucknow, Pune, Hyderabad, Bengaluru, Chennai and more." },
            ].map((p, i) => (
              <div key={p.t} className="pillar-card lift-card p-6 rounded-sm" data-testid={`pillar-${i}`}>
                <span className="text-brandred">{p.i}</span>
                <div className="font-heading font-bold text-navy mt-4">{p.t}</div>
                <div className="text-sm text-navy/70 mt-2">{p.d}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <PolicyProcedures />

      <section className="container-x section-pad">
        <div className="grid md:grid-cols-3 gap-10 items-center">
          <div className="md:col-span-2">
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-navy">Ready to discuss your funding case?</h3>
            <p className="text-muted-foreground mt-2">Free consultation. No upfront charges. NPA, low CIBIL (solution available) and rejected files welcome.</p>
          </div>
          <Link to="/contact#lead" className="bg-brandred hover:bg-brandred-700 text-white px-6 py-3 text-sm font-bold tracking-wider uppercase rounded-sm text-center" data-testid="about-cta">
            Talk to an Advisor
          </Link>
        </div>
      </section>
    </div>
  );
}
